<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类管理
    -->
  <div class="product">

    <!--添加产品分类-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" v-auth="'/product/category/add'">添加分类</el-button>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" row-key="categoryId" border default-expand-all  style="width: 100%" v-loading="loading">
          <el-table-column prop="name" align="center" label="分类名称" width="180"></el-table-column>
          <el-table-column prop="" align="center" label="图片">
            <template slot-scope="scope">
              <!-- <img v-img-url="hasImages(scope.row.images)" alt="" width="50px" /> -->
              <div style="width:100px;height:100px">
                <preview-image style="width:100%;height:100%" :srcUrl="scope.row.imagePath" > </preview-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sort" align="center" label="分类排序" width="100"></el-table-column>
          <el-table-column prop="createTime" align="center" label="添加时间" width="160"></el-table-column>
          <el-table-column fixed="right" align="center" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="primary" size="small" v-auth="'/product/category/edit'">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="danger" size="small" v-auth="'/product/category/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" :addform="categoryModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <!--修改-->
    <Edit v-if="open_edit" :open_edit="open_edit" :editform="categoryModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
import PorductApi from "@/api/product.js";
import Add from "./Add.vue";
import Edit from "./Edit.vue";
export default {
  components: {
    Add,
    Edit
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      categoryModel: {
        catList: [],
        model: {}
      }
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    hasImages(e) {
      if (e) {
        return e.filePath;
      } else {
        return "";
      }
    },

    /*获取列表*/
    getData() {
      let self = this;
      PorductApi.catList({}, true)
        .then(data => {
          console.log(data,'所有分类数据')
          self.loading = false;
          self.tableData = data.data;
          self.categoryModel.catList = self.tableData;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*打开添加*/
    addClick() {
      this.open_add = true;
    },

    /*打开编辑*/
    editClick(item) {
      this.categoryModel.model = item;
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
    },
    /*删除分类*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("删除后不可恢复，确认删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          PorductApi.catDel({
            categoryId: row.categoryId
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/category/index.vue